<script setup>
import { computed, reactive } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { useI18n } from 'vue-i18n'
import Loading from '../components/Loading.vue'
import Box from '../components/Box'
const store = useStore()
const router = useRouter()
const { t } = useI18n()
const emit = defineEmits(['update-title'])
const storeOcMapionBiz = computed(() => store.state.companiesStoreOcMapionBiz.data)
const storeOcMapionBizLoading = computed(() => store.state.companiesStoreOcMapionBiz.loading)
const searchGroups = computed(() => store.state.companiesMapionBizSearchGroups.data)
const searchGroupLoading = computed(() => store.state.companiesMapionBizSearchGroups.loading)
const storeAttributes = computed(() => store.state.companiesLocationStore.data)
const storeLoading = computed(() =>store. state.companiesLocationStore.loading)
const updateLoading = computed(() =>store. state.companiesStoreOcMapionBizSearchGroups.loading)
const readStoreOcMapionBiz = () => store.dispatch('companiesStoreOcMapionBiz/readStoreOcMapionBiz')
const readMapionBizSearchGroups = () => store.dispatch('companiesMapionBizSearchGroups/readMapionBizSearchGroups')
const readStore = () => store.dispatch('companiesLocationStore/readStore', { company_uuid, store_uuid })
const updateStoreMapionBizSearchGroup = (payload) => store.dispatch('companiesStoreOcMapionBizSearchGroups/updateStoreMapionBizSearchGroup', payload)
const { company_uuid, store_uuid } = useRoute().params
const state = reactive({
  selectConditionIds: [],
})
const checkCondition = (id, searchGroup) => {
  if(state.selectConditionIds.includes(id)) {
    state.selectConditionIds = state.selectConditionIds.filter(v => v !== id)
  } else {
    if(searchGroup.selectType === 'radio') {
      const conditionIds = searchGroup.conditions.map(v => v.id)
      state.selectConditionIds = state.selectConditionIds.filter(v => !conditionIds.includes(v))
    }
    state.selectConditionIds.push(id)
  }
}

const handleSubmit = async () => {
  const isSuccess = await updateStoreMapionBizSearchGroup({ condition_ids: state.selectConditionIds })
  if(isSuccess) router.push({ name: 'CompaniesLocationStore', params: { company_uuid, store_uuid } })
}

const load = async () => {
  readMapionBizSearchGroups()
  await Promise.all([
    readStoreOcMapionBiz(),
    readStore()
  ])
  let settingConditionIds = []
  storeOcMapionBiz.value.searchGroups.forEach(searchGroup => {
    settingConditionIds = settingConditionIds.concat(searchGroup.conditions.map(v => v.id))
  })
  state.selectConditionIds = settingConditionIds
  emit('update-title', t('pages.CompaniesLocationStoreMapionBizSearchGroupsEdit.title', { name: storeAttributes.value.attributes.name }))
}

load()
</script>

<template>
  <div>
    <div class="p-box">
      <Loading v-if="storeOcMapionBizLoading || storeLoading || searchGroupLoading || updateLoading" />
      <Box v-else>
        <template #header>
          {{ $t('pages.CompaniesLocationStore.mapionBizSearchGroupsEdit.title') }}
        </template>
        <template #body>
          <div v-for="(searchGroup, i) in searchGroups" :key="'searchGroup_' + i" class="searchGroupContainer">
            <span class="searchGroupContainer__name">{{ searchGroup.name }}</span>
            <div class="conditionContainer">
              <div v-for="(condition, j) in searchGroup.conditions" :key="`searchGroup_${ i }_condition_${ j }`">
                <input
                  :id="`condition-${ condition.id }`"
                  :checked="state.selectConditionIds.includes(condition.id)"
                  type="checkbox"
                  class="c-checkbox__input"
                  @change="checkCondition(condition.id, searchGroup)"
                >
                <label class="c-checkbox__label" :for="`condition-${ condition.id }`">
                  <div class="conditionContainer__wrap" :class="{ 'conditionContainer--closed': !searchGroup.isPublished || !condition.isPublished }">
                    <div v-if="condition.icon" class="conditionContainer__image">
                      <img :src="condition.icon" alt="">
                    </div>
                    <div class="conditionContainer__contents">
                      {{ condition.name }}
                    </div>
                  </div>
                </label>
              </div>
            </div>
          </div>
          <div class="c-button c-button--right">
            <router-link
              :to="{ name: 'CompaniesLocationStore', params: { company_uuid: company_uuid } }"
              class="c-button__item c-button__item--outline-cancel"
            >
              {{ $t('labels.cancel') }}
            </router-link>
            <button
              class="c-button__item c-button__item--primary"
              @click="handleSubmit"
            >
              {{ $t('labels.save') }}
            </button>
          </div>
        </template>
      </Box>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.searchGroupContainer {
  padding: 24px;
  border: 1px solid #E4E7EB;
  margin-bottom: 20px;
  &__name {
    font-weight: bold;
  }
  .conditionContainer {
    margin-top: 15px;
    &__wrap {
      display: flex;
      margin-right: 15px;
    }
    &__name {
      font-weight: bold;
    }
    &__contents {
      font-size: 14px;
      display: flex;
      align-items: center;
    }
    &__image {
      margin-right: 10px;
      img {
        border: 1px solid #E4E7EB;
        border-radius: 4px;
        width: 60px;
        height: 60px;
      }
    }
    &--closed {
      img {
        filter: grayscale(1) opacity(.4);
      }
    }
  }
}
</style>
